import { Account } from 'graphql-api/gql-api-interfaces';

export type ISearchResult = {
  list: Account[];
  allSearchAccountPagesLoaded: boolean;
  loaded: boolean;
};

export type IAccountsQuerySearch = string | null | undefined;

export enum AccountProperty {
  isCMIEnabled = 'isCMIEnabled',
  isVMIEnabled = 'isVMIEnabled',
  parkingReason = 'parkingReason',
  parkingDate = 'parkingDate',
  incoTerms = 'incoTerms',
}
